import React from "react";
import Page from "src/components/Page";
import Logo from "src/components/Logo";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Typography, Container } from "@material-ui/core";
import { useSelector } from "src/redux/store";

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100%",
    alignItems: "center",
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
  },
  header: {
    top: 0,
    left: 0,
    lineHeight: 0,
    width: "100%",
    position: "absolute",
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(5, 5, 0),
    },
  },
}));

// ----------------------------------------------------------------------

function Page401View() {
  const classes = useStyles();
  const { user } = useSelector((state) => state.authJwt);

  return (
    <Page title="401 Unauthorized Error | TakeMyOrder" className={classes.root}>
      <header className={classes.header}>
        <RouterLink to="/app">
          <Logo />
        </RouterLink>
      </header>

      <Container maxWidth="xl">
        <Box sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}>
          <Typography variant="h3" gutterBottom>
            401 Acceso no autorizado
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Acceso a un area no authorizada. Por favor pongase en contacto con
            un administrador.
          </Typography>

          <Box
            component="img"
            alt="500"
            src="/static/illustrations/illustration_500.svg"
            sx={{ width: "100%", maxHeight: 240, my: { xs: 5, sm: 10 } }}
          />

          <Button
            to={user?.isOnlyTpv ? "/app/tpv/camarero/carta" : "/app"}
            size="large"
            variant="contained"
            component={RouterLink}
          >
            Volver
          </Button>
        </Box>
      </Container>
    </Page>
  );
}

export default Page401View;
